import { booleanAttribute, Directive, Input, Optional } from '@angular/core';
import { Feature } from 'geojson';
import { MapDynamicData } from 'libs/map/src/lib/dynamic-data.service';
import { Subject, takeUntil } from 'rxjs';
import { SitesDataService } from './sites-data-service.service';

@Directive({
    selector: 'flyfreely-map[siteBoundaries]'
})
export class MapSiteBoundariesDirective {
    @Input({ transform: booleanAttribute }) siteBoundaries = true;

    private ngUnsubscribe$ = new Subject<void>();

    constructor(
        private dynamicDataService: MapDynamicData,
        @Optional() private sitesDataService: SitesDataService
    ) {}

    ngOnInit() {
        if (this.sitesDataService == null && this.siteBoundaries) {
            console.warn(
                'MapSiteBoundariesDirective is missing the SitesDataService but is not explicity disabled with siteBoundaries=false'
            );
        } else if (this.sitesDataService != null && this.siteBoundaries) {
            this.sitesDataService.sites$
                .pipe(takeUntil(this.ngUnsubscribe$))
                .subscribe(sites => {
                    this.dynamicDataService.setProgrammaticMapConfig(this, {
                        enabledLayerGroups: ['SITES'],
                        mapData: {
                            SITES: {
                                type: 'FeatureCollection',
                                features: sites.siteList
                                    .filter(s => !s.archived)
                                    .reduce(
                                        (acc, s) =>
                                            acc.concat(
                                                s.siteAreaList.map(area => ({
                                                    type: 'Feature',
                                                    geometry: area.boundary,
                                                    properties: {
                                                        site_name: s.name,
                                                        site_description:
                                                            s.description,
                                                        area_name: area.name
                                                    }
                                                }))
                                            ),
                                        [] as Feature[]
                                    )
                            }
                        }
                    });
                });
        }
    }

    ngOnDestroy() {
        this.dynamicDataService.clearProgrammaticMapConfig(this);
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }
}
